'use client';

import EbaRetailCalculator from "@/components/shared/eba-retail-calculator/eba-retail";

type CalculatorSectionProps = {
  heading?: string;
  add_background?: boolean;
};

export function CalculatorSection({ heading, add_background = false }: CalculatorSectionProps) {
  const content = (
    <div className="w-full">
      {heading && (
        <h2 className="text-primary-700 text-3xl font-bold mb-6">{heading}</h2>
      )}
      <EbaRetailCalculator />
    </div>
  );

  if (add_background) {
    return (
      <section className="w-screen relative left-1/2 right-1/2 -mx-[50vw] bg-gradient-to-b from-[rgba(237,237,249,0)] to-[#DEE5E8] my-8 py-8">
        <div className="bg-[url('/images/left-corner-supergrafis.png')] bg-no-repeat bg-left-bottom bg-[length:300px]">
          <div className="container max-w-7xl mx-auto items-start gap-8 flex">
            <div className="flex-1 min-w-0 px-10">
              {content}
            </div>
            <div className="w-80 flex-shrink-0 lg:block"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className="w-full">
      {content}
    </div>
  );
}
